exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*自定义iconfont文件，请将你的iconfont.css内容复制拷贝到这里就可以直接在项目里直接引用*/\r\n/*参考上面的iconfont.css内容和使用方法*/", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/assets/font/myIcon.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD,4BAA4B","file":"myIcon.css","sourcesContent":["/*自定义iconfont文件，请将你的iconfont.css内容复制拷贝到这里就可以直接在项目里直接引用*/\r\n/*参考上面的iconfont.css内容和使用方法*/"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/font/myIcon.css
// module id = 7aRa
// module chunks = 0